// PWA service worker registration for FC Staff Dashboard.
// Skipped in development to avoid stale caches during HMR.
//
// Update flow (post-hardening):
//  1. Browser fetches the new service-worker.js
//  2. New SW installs and posts SKIP_WAITING → activates immediately
//  3. `controllerchange` fires on this page → we reload ONCE so the running
//     tab picks up the new shell. The reload guard (`reloadInProgress`)
//     prevents reload loops if multiple tabs receive the event.

let reloadInProgress = false;

export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (process.env.NODE_ENV !== 'production') return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => {
        // If there's already a waiting SW (user reopened the PWA after a
        // deploy), tell it to take over right now.
        if (reg.waiting) reg.waiting.postMessage('SKIP_WAITING');

        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (
              installing.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              installing.postMessage('SKIP_WAITING');
            }
          });
        });

        // Periodically check for updates (every 15 min) so a long-lived PWA
        // tab doesn't run a deprecated build for the whole day.
        setInterval(() => {
          reg.update().catch(() => {});
        }, 15 * 60 * 1000);
      })
      .catch(() => {
        // Fail silently — PWA install is a progressive enhancement.
      });

    // The instant a new SW takes control, refresh once. iOS PWA users get
    // the latest UI without having to manually swipe-kill the app.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloadInProgress) return;
      reloadInProgress = true;
      window.location.reload();
    });
  });
}
